import {AppState} from "redux/reducers"
import {UserAppState} from "redux/reducers/user"

export const getUserState = (store:AppState):UserAppState => store.user

export const getAuthProvider = (state: AppState) => getUserState(state).authProvider
export const getVerificationSentOn = (state: AppState) => getUserState(state).verificationSentOn